import React, { useState } from 'react'
import ClickAwayListener from 'react-click-away-listener';
import Button from "../UI/Button";

export default function Range() {
    const maxValue = 20;
    const [rangeValue, setRangeValue] = useState(15);
    const [showDropdown, setShowDropdown] = useState(false);
    const rangePercentage = (rangeValue * 100) / maxValue;

    const handleChange = (e) => {
        console.log(e.target.value);
        setRangeValue(e.target.value);
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    return (
        <div className=" w-full h-full flex lg:flex-row flex-col items-center lg:items-start justify-between  lg:justify-around ">
            <div className="flex flex-col text-white my-auto">
                <span className="text-[28px] lg:text-2xl font-Red-Undead">BUY PURGE</span>
                <span className="font-Helvetica lg:text-sm opacity-[0.75] lg:opacity-1 text-white">
                    Initial Price 0.10 BNB
                </span>
            </div>
            <div className="flex-col hidden lg:flex justify-end h-[72px] w-[300px] z-10 relative">
                <div
                    className="text-white font-Helvetica text-[19px] absolute bottom-4 "
                    style={{
                        left: `${rangePercentage}%`,
                        transform: `translateX(-${rangePercentage}%)`,
                    }}
                >
                    {rangeValue}
                </div>
                <input
                    className="w-full   appearance-none cursor-pointer rounded-full h-2 "
                    style={{
                        background: `linear-gradient(to right,#61FF00 0%, #61FF00 ${rangePercentage}%, #828282 ${rangePercentage}%,#828282 100%)`,
                    }}
                    type="range"
                    min="0"
                    max={maxValue}
                    value={rangeValue}
                    onChange={handleChange}
                />
            </div>
            <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
            <div className={`lg:hidden  w-16 h-7 mt-4 mb-7`}>
                <div className='absolute -z-10'>
                    <img src="/images/home/dropdown.svg" alt="arrow" />
                </div>
                <div className='flex justify-center items-center h-full' 
                onClick={toggleDropdown}>
                    <span className='font-Helvetica text-white '>{rangeValue}</span>
                    <img src="/images/home/arrow-down.svg" alt="arrow" className='ml-4' />
                </div>
                {showDropdown && 
                <div className='absolute z-20  border-[0.78px] border-[#80FF00] w-[68.5px] py-2 bg-black'>
                    <div className='flex flex-col w-full h-full justify-center items-center '>
                        {Array.from(Array(21).keys()).map((item) => (
                            <span key={item} className='font-Helvetica text-white w-full hover:bg-[#80FF00] text-center '
                            onClick={()=>{setRangeValue(item); setShowDropdown(false)}}>
                            {item}
                            </span>
                        ))}
                    </div>
                </div>
                }
            </div>
            </ClickAwayListener>
            <div className="my-auto">
                <Button width="91px" height="36px" text="Mint" radius="13px" largeMobileText={true} />
            </div>
        </div>
    )
}
